function Footer() {
  return (
    <footer>
      <div className=""></div>
      <div className="music-creator"></div>
      <div className="contributor"></div>
    </footer>
  );
}

export default Footer;
